'use strict';

import * as Onyx from '../lib/onyx.min.js';

export default class Kelp extends Onyx.Entity {
    constructor(position = [0,0,0], scale = 1, rotation = 0){
        super();

        this.transform.translateTo(position[0], position[1], position[2]);

        Onyx.ImportModelFromOBJ.load({src: "res/models/kelp.obj"}).then((model) => {
            this.addComponent(model);
        });
    }
}